module.exports = "/_next/static/images/6775505b6473ea46e2e7d6d70ff143cb-msi-xs.png.webp";